<template>
  <v-card class="mx-1">
    <v-card-title>Promo kódy</v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="data" class="elevation-1">
        <template v-slot:item.totalSales="{ item }">
          {{ item.totalSales }} Kč
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "promo-codes",
  data() {
    return {
      data: [],
      headers: [
        { text: "Kód", value: "code" },
        { text: "Vytvořeno", value: "createdAt" },
        { text: "Naposledy upraveno", value: "updatedAt" },
        { text: "Sleva", value: "discountAmount" },
        { text: "Typ slevy", value: "discountType" },
        { text: "Počet použití", value: "usageCount" },
        { text: "Max počet použití", value: "maxUsageCount" },
        { text: "Total Sales", value: "totalSales" },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get("/v1/promo-codes")
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => this.$router.go(-1));
    },
  },
};
</script>

<style scoped></style>
